package net.zagart.ai.core.client.deepseek

data class DeepseekConfig(
    val apiKey: String,
    val baseUrl: String = "https://api.deepseek.com",
    val timeoutMillis: Long = 30_000L
)
